/**
 * NOS-132 M14: Registration toggles, deadline, and capacity (event editor).
 */

import { Label } from "@/components/ui/label"
import { Switch } from "@/components/ui/switch"
import { Input } from "@/components/ui/input"

export interface RegistrationSettingsPanelProps {
  registrationEnabled: boolean
  waitlistEnabled: boolean
  registrationDeadline: string
  capacity: string
  onRegistrationEnabledChange: (value: boolean) => void
  onWaitlistEnabledChange: (value: boolean) => void
  onRegistrationDeadlineChange: (value: string) => void
  onCapacityChange: (value: string) => void
  onRegistrationDeadlineBlur?: () => void
  onCapacityBlur?: () => void
}

export function RegistrationSettingsPanel({
  registrationEnabled,
  waitlistEnabled,
  registrationDeadline,
  capacity,
  onRegistrationEnabledChange,
  onWaitlistEnabledChange,
  onRegistrationDeadlineChange,
  onCapacityChange,
  onRegistrationDeadlineBlur,
  onCapacityBlur,
}: RegistrationSettingsPanelProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label htmlFor="registration_enabled">Enable registration</Label>
        <Switch
          id="registration_enabled"
          checked={registrationEnabled}
          onCheckedChange={onRegistrationEnabledChange}
        />
      </div>
      {registrationEnabled && (
        <>
          <div className="flex items-center justify-between">
            <Label htmlFor="waitlist_enabled">Enable waitlist</Label>
            <Switch
              id="waitlist_enabled"
              checked={waitlistEnabled}
              onCheckedChange={onWaitlistEnabledChange}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="registration_deadline">Registration deadline (optional)</Label>
            <Input
              id="registration_deadline"
              type="datetime-local"
              value={registrationDeadline}
              onChange={(e) => onRegistrationDeadlineChange(e.target.value)}
              onBlur={onRegistrationDeadlineBlur}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="capacity">Max capacity (optional)</Label>
            <Input
              id="capacity"
              type="number"
              min={0}
              value={capacity}
              onChange={(e) => onCapacityChange(e.target.value)}
              onBlur={onCapacityBlur}
              placeholder="Unlimited"
            />
          </div>
        </>
      )}
    </div>
  )
}
